import { useEffect, useState } from 'react';

export default function HeroTienda() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-[55vh] min-h-[400px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury-fashion-boutique-interior-clothing-display-elegant-minimalist-shelves-hanging-garments-soft-natural-lighting-warm-tones-editorial-photography-high-end-retail-space&width=1920&height=1080&seq=106&orientation=landscape"
          alt="Tienda Anthony Sánchez"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-14 md:pb-20 px-6 lg:px-[7%]">
        <div
          className={`transition-all duration-1000 ease-out ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="font-sans text-white/60 text-[11px] tracking-[0.2em] uppercase font-medium">
            Tienda
          </span>
          <h1 className="font-serif text-white text-[clamp(2.5rem,6vw,5rem)] font-light leading-[1.05] mt-4 max-w-3xl">
            Prendas
            <span className="block italic font-light mt-1">Seleccionadas</span>
          </h1>
          <p className="font-sans text-white/85 text-base md:text-lg max-w-xl leading-relaxed mt-5">
            Alta costura exclusiva y cápsulas prêt-à-porter de lujo.
            Cada pieza lleva la firma artesanal de Anthony Sánchez.
          </p>
        </div>
      </div>
    </section>
  );
}